import { __awaiter, __generator } from "tslib";
import { defineComponent, ref, onMounted } from 'vue';
import BaseLayout from '@/layouts/BaseLayout.vue';
import { ArrowLeftBold } from '@element-plus/icons';
import FindBikeMap from '@/components/find-bike/FindBikeMap.vue';
import { taiwanLocation } from '@/utils/location';
import bikeHandler from '@/api-handler/bike';
import CustomSelect from '@/components/common/CustomSelect.vue';
import useMessage from '@/hooks/use-message';
export default defineComponent({
    name: 'FindBike',
    components: {
        BaseLayout: BaseLayout,
        ArrowLeftBold: ArrowLeftBold,
        FindBikeMap: FindBikeMap,
        CustomSelect: CustomSelect
    },
    setup: function () {
        var _this = this;
        var taiwanLocationList = taiwanLocation;
        var selectedLocation = ref('');
        var currentPosition = ref(null);
        var searchType = ref('Rent');
        var searchInput = ref('');
        var $message = useMessage().$message;
        var getLocation = function () {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(showPosition);
            }
        };
        var showPosition = function (position) {
            var _a = position.coords, latitude = _a.latitude, longitude = _a.longitude;
            currentPosition.value = {
                lat: latitude,
                lng: longitude,
            };
        };
        var getSelectedOption = function (option) {
            selectedLocation.value = option.value;
        };
        var onSearch = function () { return __awaiter(_this, void 0, void 0, function () {
            var res, _a, PositionLat, PositionLon, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        if (selectedLocation.value === '') {
                            $message.warning('請選擇地區！');
                            return [2 /*return*/];
                        }
                        if (searchInput.value.trim() === '') {
                            $message.warning('請填入站點名稱！');
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, bikeHandler.getOneStationInfo(selectedLocation.value, searchInput.value)];
                    case 1:
                        res = _b.sent();
                        if (res) {
                            if (res.data.length === 0) {
                                $message.warning('查無相關資料！');
                            }
                            else {
                                _a = res.data[0].StationPosition, PositionLat = _a.PositionLat, PositionLon = _a.PositionLon;
                                currentPosition.value = {
                                    lat: PositionLat,
                                    lng: PositionLon
                                };
                            }
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _b.sent();
                        $message.error("" + error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        onMounted(function () {
            getLocation();
        });
        return {
            taiwanLocationList: taiwanLocationList,
            currentPosition: currentPosition,
            searchType: searchType,
            searchInput: searchInput,
            getLocation: getLocation,
            getSelectedOption: getSelectedOption,
            onSearch: onSearch,
        };
    },
});
